/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Add_Customer_InvalidInputs */



/**
* | output |
* | --- |
* | "Check the plan and email and try again." |
*
* @param {Partner_Add_Customer_InvalidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_add_customer_invalid = /** @type {((inputs?: Partner_Add_Customer_InvalidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Add_Customer_InvalidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Prüfen Sie Tarif und E-Mail und versuchen Sie es erneut.")
	return /** @type {LocalizedString} */ ("Check the plan and email and try again.")
});